var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-img"},[_c('img',{style:(_vm.styleProperty),attrs:{"src":_vm.columnProperties.value || _vm.DefaultImg,"alt":"brand logo","draggable":"false"}})])}
var staticRenderFns = []

export { render, staticRenderFns }